import { SanityPersonContacts } from '../../types/generated/graphql-types'
import { FundsContactPersonsSectionProps } from '../components/blocks/funds/FundsContactPersonsSection'
import { notEmpty } from '../utilities/filters'
import { mapSanityPersonToPersonLinkProps } from './PersonMapper'

export const mapSanityPersonContactsToFundsContactPersonsSection = ({
  gaTrackingId,
  persons,
  title,
}: SanityPersonContacts): FundsContactPersonsSectionProps => ({
  gaTrackingId: gaTrackingId ?? undefined,
  team:
    persons?.filter(notEmpty).map(person => mapSanityPersonToPersonLinkProps(person)) ??
    [],
  title: title ?? undefined,
})
